import { createSlice } from "@reduxjs/toolkit";
import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";

const profileState = {
  updatePassword: null,
  redirectToAgent: null,
  updateLanguage: null,
  profileInviteLink: null,
  error: null,
  listLoading: false,
  actionsLoading: false,
  searchLoading: false,
  isRefresh: false,
};

export const profileSlice = createSlice({
  name: "profile",
  initialState: profileState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = false;
      }
    },
    throwError: (state, action) => {
      state.error = action.payload.data.error;
    },
    startCall: (state, action) => {
      state.isRefresh = false;
      state.error = null;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = true;
      }
    },
    clearError: (state) => {
      state.error = null;
    },
    updatePasswordFetched: (state, action) => {
      state.listLoading = false;
      state.updatePassword = action.payload.data ?? {};
    },
    redirectToAgentFetched: (state, action) => {
      state.listLoading = false;
      state.redirectToAgent = action.payload.data ?? {};
    },
    updateLanguageFetched: (state, action) => {
      state.listLoading = false;
      state.updateLanguage = action.payload.data ?? {};
    },
    profileInviteLinkFetched: (state, action) => {
      state.listLoading = false;
      state.profileInviteLink = action.payload.data ?? {};
    },
  },
});
